import AnalisaBarangJadiRABApi from './AnalisaBarangJadiRABApi';

export default AnalisaBarangJadiRABApi;
